<div mat-dialog-content>
    <div class="docGroup-container-button">
        <button mat-icon-button (click)="onClose()">
            <mat-icon>clear</mat-icon>
        </button>
    </div>
    <app-documentsGroup (closeDialog)="onClose()" [docGroupformId]="docGroupformId"></app-documentsGroup>
</div>